export default function setDtrumUserAttributes(nmUniqueId, isBot) {
  try {
    if (window.dtrum) {
      window.dtrum.sendSessionProperties(null, null, {
        nmUniqueId,
        isBot: String(isBot)
      })
    }
  } catch (_) {
    // Swallow errors so a dtrum failure never prevents the login page from rendering.
  }
}
